import { Component } from '@angular/core';
import { DateTime as LuxonDateTime } from 'luxon';
import { FormatDateTimePipe } from 'src/shared/pipes/format-date-time.pipe';

import { Communication } from 'src/providers/communication/communication';
import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';

@Component({
  selector: 'messages',
  templateUrl: 'messages.html',
})

export class MessagesPage {

  messages: any;
  loaded: boolean;
  customBackRoute: string;
  fromNotification: boolean;

  constructor(
    public communication: Communication,
    private navCtrl: CustomNavController,
  ) {}

  async ionViewDidEnter() {
    this.loaded = false;

    // Check if we came from a notification
    const navigationState = history.state;
    this.customBackRoute = navigationState?.customBackRoute;
    this.fromNotification = navigationState?.fromNotification;

    const messages = await this.communication.getLatestMessages();
    this.messages = this.parseAndSortMessagesByDate(messages);
    this.dontShowProMessagesAsUnread();
    this.loaded = true;
  }

  parseAndSortMessagesByDate(messages) {
    const array: any = [];
    messages.map((message) => {
      message.chat_rooms.map((chatRoom) => {
        array.push({
          chatRoom: chatRoom,
          job: message.job,
          type: message.type
        });
      });
    });
    array.sort((a, b) => a.chatRoom.last_chat_room_message.sent_at < b.chatRoom.last_chat_room_message.sent_at ? 1 : -1);
    return array;
  }

  dontShowProMessagesAsUnread() {
    this.messages.map((message) => {
      if (message.chatRoom.last_chat_room_message.from_member.type == 'Homekeeper' && !message.chatRoom.last_chat_room_message.is_read) {
        message.chatRoom.last_chat_room_message.is_read = true;
      }
    });
  }

  goToMessagesPage(message) {
    localStorage.setItem('clientMessagesBackPage', 'messages');
    const params = {
      phoneNumber: message.chatRoom.chat_phone_number,
      displayName: message.chatRoom.display_name,
      isPrivate: message.chatRoom.is_private
    }
    this.navCtrl.navigateForward(`client-messages/${message.chatRoom.data.customer_account_id}`, params);
  }

  getMessageDateTime(message) {
    const date = message?.chatRoom?.last_chat_room_message?.sent_at;
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const relativeDate = LuxonDateTime.fromISO(date).setZone(timezone).toRelative();
    if (relativeDate.includes('day') || relativeDate.includes('month') || relativeDate.includes('year')) {
      return (new FormatDateTimePipe().transform(LuxonDateTime.fromISO(date).setZone(timezone).toISO(), 'EEE LLL d')) + ' ' + (new FormatDateTimePipe().transform(LuxonDateTime.fromISO(date).setZone(timezone).toISO(), 'h:mma'));
    } else {
      return relativeDate;
    }
  }

}
